<template>
  <tr>
    <td class="align-middle text-center">{{ index + 1 }}</td>
    <td>
      <input type="text" :class="['form-control form-control-sm', fieldErr('registered_name') && 'is-invalid']" v-model="row.registeredName" />
      <div v-if="fieldErr('registered_name')" class="text-danger small">{{ fieldErr('registered_name') }}</div>
    </td>
    <td>
      <input type="text" :class="['form-control form-control-sm', fieldErr('breed') && 'is-invalid']" v-model="row.breed" />
      <div v-if="fieldErr('breed')" class="text-danger small">{{ fieldErr('breed') }}</div>
    </td>
    <td>
      <input type="text" :class="['form-control form-control-sm', fieldErr('sex') && 'is-invalid']" v-model="row.sex" />
      <div v-if="fieldErr('sex')" class="text-danger small">{{ fieldErr('sex') }}</div>
    </td>
    <td>
      <input type="text" :class="['form-control form-control-sm', fieldErr('identification_marks') && 'is-invalid']" v-model="row.identificationMarks" />
      <div v-if="fieldErr('identification_marks')" class="text-danger small">{{ fieldErr('identification_marks') }}</div>
    </td>
    <td>
      <input type="text" :class="['form-control form-control-sm', fieldErr('pic') && 'is-invalid']" v-model="row.pic" />
      <div v-if="fieldErr('pic')" class="text-danger small">{{ fieldErr('pic') }}</div>
    </td>
    <td class="align-middle text-center">
      <app-button v-if="removable" variant="outline-danger" size="sm" @click="$emit('remove')">✕</app-button>
    </td>
  </tr>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import AppButton from '@/components/AppButton'

export default defineComponent({
  name: 'BiosecurityHorseRow',
  components: { AppButton },
  props: {
    index: { type: Number, required: true },
    value: { type: Object, required: true },
    removable: { type: Boolean, default: false },
    errors: { type: Object, default: () => ({}) }
  },
  emits: ['remove', 'input'],
  setup(props, { emit }) {
    const row = computed({
      get: () => props.value,
      set: val => emit('input', val)
    })

    function fieldErr(field) {
      const key = `horses_data.${props.index}.${field}`
      const errs = props.errors[key]
      return errs && errs.length > 0 ? errs[0] : null
    }

    return { row, fieldErr }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/Biosecurity/BiosecurityHorseRow.vue